import { WidgetProps } from '@rjsf/utils';
import * as React from 'react';
import { useState } from 'react';
import { Checkbox, FormField } from '@amzn/awsui-components-react-v3';
import { Link } from 'src/components/common/Link';

export function CheckboxOnlyAfterClickLinkWidget(props: WidgetProps) {
  const url = props.schema.omniAcknowledgementLink;

  const [checked, setChecked] = useState<boolean>(props.value);
  const [disabled, setDisabled] = useState<boolean>(!!url && !checked);
  if (url) {
    return (
      <FormField label={disabled ? 'Open the link to enable the checkbox:' : undefined}>
        <Checkbox
          readOnly={props.readonly}
          checked={checked}
          disabled={props.readonly || (!checked && disabled)}
          onChange={(event) => {
            if (props.readonly) return;
            setChecked(event.detail.checked);
            props.onChange(event.detail.checked);
          }}
        >
          {props.label}{' '}
          <Link
            external={true}
            onClick={() => {
              if (props.readonly) return;
              setDisabled(false);
            }}
            href={url}
          >
            Link
          </Link>
        </Checkbox>
      </FormField>
    );
  } else {
    return (
      <FormField>
        <Checkbox
          disabled={props.readonly}
          checked={checked}
          onChange={(event) => {
            setChecked(event.detail.checked);
            props.onChange(event.detail.checked);
          }}
        >
          {props.label}
        </Checkbox>
      </FormField>
    );
  }
}
CheckboxOnlyAfterClickLinkWidget.defaultProps = {
  options: {
    url: 'https://omni.datalake.aws.a2z.com/',
  },
};
